import { Td, Tr } from './styles';

interface IMaterialItem {
  materialDesc: string;
  diteCodigo: string;
  quantidade: number;
  custoUnitario?: number | null;
  custoTotal?: number | null;
  mostrarCusto?: boolean;
  fabricante?: string;
}

export default function MaterialItem({
  diteCodigo,
  quantidade,
  materialDesc,
  custoUnitario,
  custoTotal,
  mostrarCusto,
  fabricante,
}: IMaterialItem): JSX.Element {
  const formatarMoeda = (valor: number | null | undefined): string => {
    if (valor === null || valor === undefined) return '-';
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  return (
    <Tr>
      <Td>{diteCodigo}</Td>
      <Td>
        {materialDesc}
        {fabricante && (
          <small
            style={{ display: 'block', color: '#6c757d', marginTop: '2px' }}
          >
            Fornecedor: {fabricante}
          </small>
        )}
      </Td>
      <Td>{quantidade}</Td>
      {mostrarCusto && (
        <>
          <Td>{formatarMoeda(custoUnitario)}</Td>
          <Td>{formatarMoeda(custoTotal)}</Td>
        </>
      )}
    </Tr>
  );
}
